module.exports = __webpack_public_path__ + "static/media/logo1.ee8733c6.png";